import React, { useState, useEffect } from 'react';

const BrowserRecommendation = ({ variant = 'banner' }) => {
  const [isChrome, setIsChrome] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Détecter si c'est Chrome
    const isChromeBrowser = /Chrome/.test(navigator.userAgent) && !/Edg|Edge/.test(navigator.userAgent);
    console.log('🌐 BrowserRecommendation - userAgent:', navigator.userAgent);
    console.log('🌐 BrowserRecommendation - isChrome:', isChromeBrowser);
    console.log('🌐 BrowserRecommendation - dismissed:', sessionStorage.getItem('browser-recommendation-dismissed'));
    setIsChrome(isChromeBrowser);
    
    // Vérifier si déjà dismissé
    const wasDismissed = sessionStorage.getItem('browser-recommendation-dismissed');
    if (wasDismissed) setDismissed(true);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('browser-recommendation-dismissed', 'true');
  };

  console.log('🌐 BrowserRecommendation - RENDER - isChrome:', isChrome, 'dismissed:', dismissed);

  // Ne pas afficher si Chrome ou si dismissé
  if (isChrome || dismissed) {
    console.log('🌐 BrowserRecommendation - NOT SHOWING');
    return null;
  }

  console.log('🌐 BrowserRecommendation - SHOWING banner');
  // ... reste du code

  // Ne pas afficher si Chrome ou si dismissé
  if (isChrome || dismissed) return null;

  // Style banner (pour pages login/inscription)
  if (variant === 'banner') {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)',
        border: '1px solid #f59e0b',
        borderRadius: '12px',
        padding: '16px 20px',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '15px',
        boxShadow: '0 2px 8px rgba(245, 158, 11, 0.15)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '24px' }}>🌐</span>
          <div>
            <strong style={{ color: '#92400e', display: 'block', marginBottom: '2px' }}>
              Navigateur recommandé : Google Chrome
            </strong>
            <span style={{ color: '#a16207', fontSize: '14px' }}>
              Pour une meilleure expérience vidéo, nous recommandons d'utiliser Chrome ou Firefox.
            </span>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#92400e',
            fontSize: '20px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          ✕
        </button>
      </div>
    );
  }

  // Style compact (pour CoursVideo)
  if (variant === 'compact') {
    return (
      <div style={{
        background: '#fff3cd',
        borderRadius: '8px',
        padding: '10px 15px',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '13px'
      }}>
        <span style={{ color: '#92400e' }}>
          ⚠️ Pour une meilleure qualité vidéo, utilisez <strong>Chrome</strong> ou <strong>Firefox</strong>
        </span>
        <button
          onClick={handleDismiss}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#92400e',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          ✕
        </button>
      </div>
    );
  }

  return null;
};

export default BrowserRecommendation;
